export default defineNuxtPlugin(() => {
  const config = useRuntimeConfig()
  const GTM_ID = config.public.gtm

  if (!GTM_ID) {
    return
  }

  // 初始化 dataLayer
  window.dataLayer = window.dataLayer || []
  window.dataLayer.push({
    'gtm.start': new Date().getTime(),
    event: 'gtm.js',
  })

  // 動態載入 GTM 腳本（非阻塞）
  const script = document.createElement('script')
  script.async = true
  script.src = `https://www.googletagmanager.com/gtm.js?id=${GTM_ID}`
  document.head.appendChild(script)

  // 提供 GTM push 方法
  const gtmPush = (data) => {
    window.dataLayer.push(data)
  }

  return {
    provide: {
      gtmPush,
    },
  }
})
